import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e584eb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "zeroCoverage",
  class: "zero-coverage"
}
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-3" }, "Bummer!", -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "form-row" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "form-group email-form-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "d-none"
}, "Submit", -1))
const _hoisted_11 = {
  key: 0,
  class: "oom-footer"
}
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_name_input = _resolveComponent("name-input")!
  const _component_email_input = _resolveComponent("email-input")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("form", {
      class: "zero-coverage-form",
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendToBetaContacts && _ctx.sendToBetaContacts(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("img", {
          src: _ctx.asset(require(`@/assets/images/no_shop_placeholder@2x.png`)),
          alt: "Choose or describe your service",
          class: "img-fluid mb-3"
        }, null, 8, _hoisted_4),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.copy), 1)
      ]),
      (!_ctx.isAdminFlow)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_name_input, {
                  modelValue: _ctx.firstName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstName) = $event)),
                  placeholder: "First Name",
                  onNameUpdate: _ctx.updateFirstName
                }, null, 8, ["modelValue", "onNameUpdate"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_name_input, {
                  modelValue: _ctx.lastName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastName) = $event)),
                  placeholder: "Last Name",
                  onNameUpdate: _ctx.updateLastName
                }, null, 8, ["modelValue", "onNameUpdate"])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_email_input, {
                modelValue: _ctx.email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
                onEmailUpdate: _ctx.updateEmail,
                onEmailValidUpdate: _ctx.updateEmailValidity
              }, null, 8, ["modelValue", "onEmailUpdate", "onEmailValidUpdate"])
            ]),
            _hoisted_10
          ], 64))
        : _createCommentVNode("", true)
    ], 32),
    (!_ctx.isAdminFlow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("button", {
            class: "btn btn-link",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cancel()))
          }, _toDisplayString(_ctx.cancelText), 1),
          _createElementVNode("button", {
            disabled: !_ctx.firstName || !_ctx.lastName || !_ctx.email || !_ctx.emailValid,
            class: "btn btn-primary",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.sendToBetaContacts && _ctx.sendToBetaContacts(...args)))
          }, " Notify Me ", 8, _hoisted_12)
        ]))
      : _createCommentVNode("", true)
  ], 512))
}